import image1 from "../assets/t-image1.png";
import image2 from "../assets/t-image2.jpg";
import image3 from "../assets/t-image3.jpg";

export const testimonialsData = [
  {
    image: image1,
    review:
      "We made the right choice by choosing the Fitclub and by choosing the right plan and program we already achieved our ideal body!",
    name: 'Andrew and Martha',
    status : 'DOCTOR'
  },
  {
    image: image2,
    review: 'High quality, diverse group classes; equipments in good condition; friendly community  ',
    name: 'Hritik Roshan',
    status: 'ACTOR'
  },
  {
    image : image3,
    review:' Great hours, low costs, nice and friendly environment and it has everything i need for a workout and it is close to my home',
    name: 'Rihana',
    status: "CUSTOMER"
  }
];
